var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCurrencyDollar = function SvgIconCurrencyDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 2.25a1 1 0 1 0-2 0V3.5h-.875a4.75 4.75 0 1 0 0 9.5H11v5.5H9.75A2.75 2.75 0 0 1 7 15.75a1 1 0 1 0-2 0 4.75 4.75 0 0 0 4.75 4.75H11v1.25a1 1 0 1 0 2 0V20.5h1.25a4.75 4.75 0 1 0 0-9.5H13V5.5h.5a2.75 2.75 0 0 1 2.75 2.75 1 1 0 1 0 2 0A4.75 4.75 0 0 0 13.5 3.5H13zM11 5.5h-.875a2.75 2.75 0 1 0 0 5.5H11zm2 7.5v5.5h1.25a2.75 2.75 0 1 0 0-5.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconCurrencyDollar;